// @flow

import { observer } from "mobx-react";
import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import ToggleButton from "react-toggle-button";
import Overlay from "app/components/Overlay/Overlay";
import ShareMedia from "app/components/ShareMedia/ShareMedia";
import ImageHelper from "app/util/ImageHelper";

import "./ShareBox.scss";

type Props = {
    url: string,
    onShare: Function,
    onClose: Function,
    onFeedback: Function,
    thumbnail: String
};

type State = {
    embed: Boolean;
    hideThumbnails: Boolean,
    embedSize: String,
    embedTag: String,
}

@observer
export default class ShareBox extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.handleToggleHideThumbnails = this.handleToggleHideThumbnails.bind(this);
        this.handleEmbedSizeChange = this.handleEmbedSizeChange.bind(this);
        this.embedTag = this.embedTag.bind(this);
        this.state = {
            embed: false,
            hideThumbnails: true,
            embedSize: "780x700",
            embedTag: this.embedTag("780x700", true),
        };
    }

    embedTag(embedSize, hideThumbnails) {
        let [width, height] = embedSize.split("x");
        const url =
            this.props.url +
            `&embed=1&hide_thumbnails=${hideThumbnails ? "1" : 0}`;
        return `<iframe width="${width}" height="${height}" src="${url}" frameborder="0"></iframe>`
    }

    handleToggleHideThumbnails() {
        this.setState({
            hideThumbnails: !this.state.hideThumbnails,
            embedTag: this.embedTag(this.state.embedSize, !this.state.hideThumbnails)
        });
    }

    handleEmbedSizeChange(e: SyntheticEvent<HTMLInputElement>) {
        this.setState({
            embedSize: e.currentTarget.value,
            embedTag: this.embedTag(e.currentTarget.value, this.state.hideThumbnails)
        });
    }

    handleCheckEmbed(e) {
        e.preventDefault();
        this.setState({
            embed: !this.state.embed
        })
    }

    renderShare() {
        if (this.state.embed) return null;

        return (
            <div>
                <div className="ShareBox__title">
                    Share with your friends
                </div>
                <div className="ShareMedia ShareMedia__embed" key="embed">
                    <button onClick={this.handleCheckEmbed.bind(this)} className="EmailShareMedia" title="Embed on your site">
                        <i className="fa fa-angle-left"></i>&nbsp;<i className="fa fa-angle-right"></i>
                    </button>
                </div>
                {Object.keys(ShareMedia.types).map(type => (
                    <ShareMedia
                        key={type}
                        url={this.props.url}
                        title={document.title}
                        type={type}
                        onShare={() => this.props.onShare(type)}
                    />
                ))}
                <div className="ShareBox__clipboard">
                    <div className="input-group">
                        <input
                            type="text"
                            className="ShareBox__input form-control"
                            value={this.props.url}
                            readOnly
                        />
                        <div className="input-group-btn">
                            <CopyToClipboard text={this.props.url}>
                                <button
                                    className="btn btn-default"
                                    title="Copy to Clipboard"
                                >
                                    Copy
                                </button>
                            </CopyToClipboard>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderEmbed() {
        if (!this.state.embed) return null;

        const thumbnail = ImageHelper.makeUrl(this.props.thumbnail);

        return (
            <div className="row">
                <div className="ShareBox__thumbnail col-md-8">
                    <img src={thumbnail} alt="Video" />
                </div>

                <div className="col-md-4">
                    <div className="ShareBox__title">
                        Embed Video
                    </div>

                    <div className="ShareBox__clipboard ShareBox__embed">
                        <div>
                            <textarea
                                type="text"
                                className="ShareBox__textarea"
                                value={this.state.embedTag}
                                readOnly/>
                        </div>
                        <div className="ShareBox__toggleContainer">
                            <div className="ShareBox__toggle">
                                <ToggleButton
                                    value={this.state.hideThumbnails}
                                    onClick={this.handleToggleHideThumbnails}
                                />
                                <span onClick={this.handleToggleHideThumbnails}>
                                    Hide Thumbnail
                                </span>
                            </div>
                        </div>
                        <div className="ShareBox__selectEmbedSize">
                            <label>
                                <input
                                    type="radio"
                                    value="780x700"
                                    checked={this.state.embedSize === "780x700"}
                                    onChange={this.handleEmbedSizeChange}
                                />{" "}
                                780x700
                            </label>
                            <label>
                                <input
                                    type="radio"
                                    value="720x640"
                                    checked={this.state.embedSize === "720x640"}
                                    onChange={this.handleEmbedSizeChange}
                                />{" "}
                                720x640
                            </label>
                            <label>
                                <input
                                    type="radio"
                                    value="360x320"
                                    checked={this.state.embedSize === "360x320"}
                                    onChange={this.handleEmbedSizeChange}
                                />{" "}
                                360x320
                            </label>
                        </div>
                        <div className="ShareBox__footer">
                            <CopyToClipboard text={this.state.embedTag}>
                                <button
                                    className="btn btn-default"
                                    title="Copy to Clipboard"
                                >
                                    Copy
                                </button>
                            </CopyToClipboard>
                        </div>
                    </div>

                </div>

            </div>
        );
    }


    render() {
        return (
            <div className="ShareBox">
                <Overlay active={true} onClick={this.props.onClose} />

                <div className="ShareBox__body">
                    { this.state.embed &&
                        <button
                            type="button"
                            onClick={this.handleCheckEmbed.bind(this)}
                            className="ShareBox__back"
                        >
                            <i className="fa fa-arrow-left" />
                        </button>
                    }
                    <button
                        type="button"
                        onClick={this.props.onClose}
                        className="ShareBox__cancel"
                    >
                        <i className="fa fa-remove" />
                    </button>

                    {this.renderShare()}
                    {this.renderEmbed()}

                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ShareBox/ShareBox.js